export const refreshDeviceList = () => {
  navigator.mediaDevices?.dispatchEvent(new Event('devicechange'))
}
